import React from 'react';

export const orderCashMovementConfig = [
  {
    path: '/order-cash-movement',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/order-cash-movement/rincian-order-cash-movement',
    component: React.lazy(() => import('./rincianOrder/rincianOrder')),
  },
  {
    path: '/order-cash-movement/detail-rincian-order-cash-movement',
    component: React.lazy(() => import('./detail/detail')),
  },
];
